export const Expander = (expanded = false) => ({
  isExpanded: expanded,

  toggle() {
    this.isExpanded = !this.isExpanded
  },
})
